const timeTextLocales = {
    en: 'Time',
    'zh-hant': '時間',
    'zh-cn': '时间',
    vi: 'thời gian',
    th: 'เวลา',
};
export const getDefaultTimeText = (lang) => timeTextLocales[lang] || timeTextLocales.en;
export const HOUR_FORMAT = 'ha'; // due to designer's spec, just hard code here for now
export { default as DateTimePicker } from './DateTimePicker';
export { default as DateTimeRangePicker } from './DateTimeRangePicker';
//# sourceMappingURL=index.js.map